var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800293 9C0.800293 11.1217 1.64315 13.1566 3.14344 14.6569C4.64373 16.1571 6.67856 17 8.80029 17C10.922 17 12.9569 16.1571 14.4571 14.6569C15.9574 13.1566 16.8003 11.1217 16.8003 9C16.8003 6.87827 15.9574 4.84344 14.4571 3.34315C12.9569 1.84285 10.922 1 8.80029 1C6.67856 1 4.64373 1.84285 3.14344 3.34315C1.64315 4.84344 0.800293 6.87827 0.800293 9V9Z",
    stroke: "#77629D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3291 11.1299H8.1875L8.09863 3.98633H9.4248L9.3291 11.1299ZM8.05078 13.3037C8.05078 13.0986 8.1123 12.9277 8.23535 12.791C8.36296 12.6497 8.5498 12.5791 8.7959 12.5791C9.04199 12.5791 9.22884 12.6497 9.35645 12.791C9.48405 12.9277 9.54785 13.0986 9.54785 13.3037C9.54785 13.5088 9.48405 13.6797 9.35645 13.8164C9.22884 13.9486 9.04199 14.0146 8.7959 14.0146C8.5498 14.0146 8.36296 13.9486 8.23535 13.8164C8.1123 13.6797 8.05078 13.5088 8.05078 13.3037Z",
    fill: "#77629D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.49c900f6b45a67dd0b8428baa2b4722d.svg";
export { ForwardRef as ReactComponent };